module.exports = __webpack_public_path__ + "static/media/header_rollerfahrer.d05581cb.jpg";